import styled from 'styled-components';

export const StyledForm = styled.form`
  margin: 0 auto;
`;
